import React from "react";
import { TabbedInterface } from "../../../components/layout/tabbed-interface/TabbedInterface";
import { RestrictedBrands } from "./tabs/restricted-brands/RestrictedBrands";
import { RestrictedCategories } from "./tabs/restricted-categories/RestrictedCategories";
import { RestrictedKeywords } from "./tabs/restricted-keywords/RestrictedKeywords";
import { RestrictedProducts } from "./tabs/restricted-products/RestrictedProducts";
import { useTranslation } from "../../../hooks/useTranslation";
export const Restrictions = () => {
  const { translate } = useTranslation("pages.storeSecurity.restrictions");
  const tabs = [
    {
      label: "restrictedBrands.title",
      path: "brand",
      component: <RestrictedBrands />,
    },
    {
      label: "restrictedCategories.title",
      path: "category",
      component: <RestrictedCategories />,
    },
    {
      label: "restrictedKeywords.title",
      path: "keyword",
      component: <RestrictedKeywords />,
    },
    {
      label: "restrictedProducts.title",
      path: "product",
      component: <RestrictedProducts />,
    },
  ];

  return (
    <TabbedInterface tabs={tabs} defaultPath="brand" translate={translate} />
  );
};
